import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { EmployeesComponent } from "./employees/employees.component";
import { ProjectComponent } from "./project/project.component";
import { TasksComponent } from "./tasks/tasks.component";
import { SidebarComponent } from "../common/sidebar/sidebar.component";
import { AddTaskComponent } from "./tasks/add-task/add-task.component";
import { AddEmployeeComponent } from "./employees/add-employee/add-employee.component";

import { LokedTimesheetComponent } from "./loked-timesheet/loked-timesheet.component";
import { PlanedActualComponent } from "./planed-actual/planed-actual.component";

import { AddProjectComponent } from "./project/add-project/add-project.component";
import { AdminGuard } from "./admin.guard";
import { AuditLogComponent } from "./audit-log/audit-log.component";
import { NotificationComponent } from "../common/notification/notification.component";
import { ProfileComponent } from "../common/profile/profile.component";
import { ReportsComponent } from "./reports/reports.component";
import { EditTimesheetComponent } from "./edit-timesheet/edit-timesheet.component";
import { NonComplianceListComponent } from "./non-compliance-list/non-compliance-list.component";
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: "admin",
    component: SidebarComponent,
    canActivate: [MsalGuard],
    //canActivateChild: [AdminGuard],
    children: [
      {
        path: "",
        component: DashboardComponent,
      },
      {
        path: "dashboard",
        component: DashboardComponent,
      },
      {
        path: "audit",
        component: AuditLogComponent,
      },
      {
        path: "profile",
        component: ProfileComponent,
      },
      {
        path: "notification",
        component: NotificationComponent,
      },
      {
        path: "reports",
        component: ReportsComponent,
      },
      {
        path: "edit-timesheet",
        component: EditTimesheetComponent,
      },
      {
        path: "employees",
        children: [
          {
            path: "",
            component: EmployeesComponent,
          },
          {
            path: "add-employee",
            component: AddEmployeeComponent,
          },
        ],
      },
      {
        path: "project",
        children: [
          {
            path: "",
            component: ProjectComponent,
          },
          {
            path: "add-project",
            component: AddProjectComponent,
          },
          {
            path: "add-project/:id",
            component: AddProjectComponent,
          },
        ],
      },
      {
        path: "locked-timesheet",
        component: LokedTimesheetComponent,
      },
      {
        path: "locked-list",
        component: NonComplianceListComponent,
      },
      {
        path: "planed-actual",
        component: PlanedActualComponent,
      },
      {
        path: "tasks",
        children: [
          {
            path: "",
            component: TasksComponent,
          },
          {
            path: "add-task",
            component: AddTaskComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/admin/admin-routing.module.ts